module.exports = __webpack_public_path__ + "static/img/me3.381a6b66.png";